/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { ERC165Base__factory } from "./ERC165Base__factory";
export { ERC165BaseInternal__factory } from "./ERC165BaseInternal__factory";
export { IERC165Base__factory } from "./IERC165Base__factory";
export { IERC165BaseInternal__factory } from "./IERC165BaseInternal__factory";
